module.exports = __webpack_public_path__ + "img/logo.6f043ed4.svg";